import React from 'react';
import { ArrowRight } from 'lucide-react';

const ProtocolCrossReference = ({ protocolId, protocolTitle, onNavigate }) => {
  const handleClick = () => {
    onNavigate(protocolId);
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-teal-100 dark:bg-teal-900/30 hover:bg-teal-200 dark:hover:bg-teal-800/50 rounded-lg transition-colors group"
    >
      <ArrowRight size={16} className="text-teal-600 dark:text-teal-400 group-hover:translate-x-0.5 transition-transform" />
      <span className="text-sm font-semibold text-teal-900 dark:text-teal-100">
        {protocolTitle || protocolId}
      </span>
    </button>
  );
};

export default ProtocolCrossReference;
